module.exports = __webpack_public_path__ + "img/service2.6d300e28.png";